<template>
  <Modal position="center" style="border-radius: 0.32rem" :closeable="closeable" :show="show" @close="emit('close')"
    @update:show="(val: boolean) => emit('update:show', val)" widthFitContent>
    <div :class="!targetItem.toastSmall ? 'toast-content' : 'toast-content-small'">
      <img src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/btnMask.png"
        style="
        width: 100%;
        height: 1.3rem;
        position: absolute;
        bottom: 0;
      "/>
      <div class="box">
        <img v-if="targetItem?.icon" class="icon" :src="targetItem?.icon" />
        <div v-if="targetItem?.title" class="title">
          {{ targetItem?.title }}
        </div>
        <div v-if="targetItem?.desc" class="desc" v-html="targetItem?.desc"></div>
        <img v-if="targetItem?.qrCode" class="qrCode" :src="targetItem?.qrCode" />
      </div>
      <Button v-if="targetItem?.btnText" round :type="type === 'success' ? 'primary' : undefined"
        :class="`btn btn-${type}`" @click="handleClick">
        {{ targetItem?.btnText }}
      </Button>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Button from "../common/button.vue";
import Modal from "../common/modal.vue";
import { defaults } from "lodash-es";

export interface ToastModalProps {
  show?: boolean;
  type: "error" | "success" | "permission" | "openKy" | "KyApp" | 'loginError' | 'loginKwai';
  toastSmall?: boolean; // 弹窗样式
  title?: string;
  desc?: string;
  icon?: string;
  btnText?: string;
  jumpUrl?: string;
  qrCode?: string;
  autoClose?: boolean;
  closeable?: boolean;
}
const props = withDefaults(defineProps<ToastModalProps>(), { autoClose: true, closeable: true });

type Event = {
  (e: "update:show", show: boolean): void;
  (e: "close"): void;
  (e: "confirm"): void;
};
interface ModalItem extends Omit<ToastModalProps, "type" | "show"> { }

const emit = defineEmits<Event>();

const modalMaps: Record<ToastModalProps["type"], ModalItem> = {
  success: {
    title: "投稿成功",
    desc: "<p>&nbsp&nbsp&nbsp&nbsp&nbsp8月12日至14日公布获奖名单</p><p>你也可继续投稿，获奖可能性更大哦</p>",
    icon: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/101b612d-cdf5-47f2-a558-f7074d79c941.png`,
    btnText: "继续投稿",
    toastSmall: false,
  },
  error: {
    title: "投稿失败",
    desc: "",
    icon: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/343d9bcc-bbdd-4e2c-8eb5-c95cd5d48178.png`,
    btnText: "我知道了",
    toastSmall: false,
  },
  permission: {
    title: "你未有“可灵”使用权限",
    desc: "需要前往申请权限，才能参与活动哦！",
    btnText: "立即申请",
    toastSmall: true,
  },
  openKy: {
    title: "需要打开快影APP才能参与",
    desc: "你可以在「快影-AI视频」创作更多视频",
    btnText: "打开快影",
    toastSmall: true,
   },
  KyApp: {
    title: "需要打开快影APP才能参与",
    desc: "你可以在「快影-AI视频」创作更多视频",
    qrCode: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/bdb69e86-2ef0-49ba-b24a-c342646a83d7.png`,
    toastSmall: false,
  },
  loginError: {
    title: "登录失败",
    icon: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/343d9bcc-bbdd-4e2c-8eb5-c95cd5d48178.png`,
    desc: '',
    btnText: "我知道了",
    toastSmall: true,
  },
  loginKwai: {
    title: "当前账号没有权限",
    icon: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/343d9bcc-bbdd-4e2c-8eb5-c95cd5d48178.png`,
    desc: '需要绑定快手账号再投稿',
    btnText: "去绑定",
    toastSmall: true,
  },
};

const targetItem = computed(() => defaults({}, props, modalMaps[props?.type]));

const handleClick = () => {
  if (props.autoClose) emit("update:show", false);
  emit("confirm");
  if (targetItem.value?.jumpUrl) window.open(targetItem.value?.jumpUrl);
};
</script>

<style scoped lang="less">
.toast-content-small {
  width: 6.72rem;
  padding-top: 0.8rem;
  padding-bottom: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9999;
  background-color: rgba(26, 27, 34, 1);

  @media screen and (max-width: 1360px) {
    width: 6.3rem;
    height: 3.8rem;
    padding-top: 0.8rem;
    padding-bottom: 0rem;
  }

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.64rem;

    @media screen and (max-width: 1360px) {
      margin-bottom: 0.4rem;
    }

    .icon {
      width: 1.28rem;
      height: 1.28rem;
      margin-bottom: 0.4rem;

      @media screen and (max-width: 1360px) {
        margin-bottom: 0.24rem;
      }
    }

    .title {
      color: #fff;
      font-size: 0.4rem;
      font-weight: 400;
      line-height: 0.48rem;
      margin-bottom: 0.24rem;

      @media screen and (max-width: 1360px) {
        font-size: 0.3rem;
        line-height: 0.42rem;
        font-weight: 500;
      }
    }

    .desc {
      font-size: 0.3rem;
      font-weight: 300;
      line-height: 0.48rem;
      color: rgba(255, 255, 255, 0.5);

      @media screen and (max-width: 1360px) {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.36rem;
      }
    }

    .qrCode {
      width: 3.2rem;
      height: 3.2rem;
      border-radius: 0.24rem;
      margin-top: 0.3rem;
    }
  }

  .btn {
    font-size: 0.3rem;
    line-height: 0.42rem;
    font-weight: 500;
    padding: 0 0.98rem;
    height: 0.88rem;
    z-index: 2;

    &-error {
      color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.06);
    }
  }
}
.toast-content {
  width: 6.72rem;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10000;
  // background-color: #222;
  @media screen and (max-width: 1360px) {
    width: 5.8rem;
    padding-bottom: 0rem;
    padding-top: 0.8rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.64rem;

    @media screen and (max-width: 1360px) {
      margin-bottom: 0.4rem;
    }

    .icon {
      width: 1.28rem;
      height: 1.28rem;
      margin-bottom: 0.4rem;

      @media screen and (max-width: 1360px) {
        margin-bottom: 0.24rem;
      }
    }

    .title {
      color: #fff;
      font-size: 0.4rem;
      font-weight: 400;
      line-height: 0.48rem;
      margin-bottom: 0.24rem;

      @media screen and (max-width: 1360px) {
        font-size: 0.3rem;
        line-height: 0.42rem;
        font-weight: 500;
      }
    }

    .desc {
      font-size: 0.3rem;
      font-weight: 300;
      line-height: 0.48rem;
      color: rgba(255, 255, 255, 0.5);

      @media screen and (max-width: 1360px) {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.36rem;
      }
    }

    .qrCode {
      width: 3.2rem;
      height: 3.2rem;
      border-radius: 0.24rem;
      margin-top: 0.3rem;
    }
  }

  .btn {
    font-size: 0.3rem;
    line-height: 0.42rem;
    font-weight: 500;
    padding: 0 0.98rem;
    height: 0.88rem;
    z-index: 2;

    &-error {
      color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.06);
    }
  }
}
</style>
